import { AppointmentType } from "./AppointmentType";
import { TimeRange } from "./TimeRange";

export type AppointmentConfiguration = {
  treatmentTitle: string | null;
  treatmentName: string | null;
  bookingLinkId: string;
  startDate: string;
  endDate: string | null;
  noEndDate: boolean;
  duration: number;
  appointmentTypes?: AppointmentType[] | null; 
  //appointmentMode: 'fixed-duration' | 'types';  // 'fixed-duration' ==> "duration - durationValue" / 'types' => "appointmentTypes"
  appointmentMode: AppointmentMode;
  activeDays: string[];
  timeRanges: TimeRange[];
  clinicId: string | null;
  _id?: string; // Include `_id` if MongoDB returns it
}

export enum AppointmentMode {
  FixedDuration = 'fixed-duration',
  Types = 'types',
}
